import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LandscapeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"landscape"}/>
}
